import React, { useMemo, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Star, X, Plus } from "lucide-react";
import { PhotoEditor } from "@/components/erp/catalog/PhotoEditor";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const MAX_PHOTOS = 5;

const Thumb = ({ src, main, tid, onDel, onMain }) => (
  <div className="relative w-20 h-20" data-testid={tid}>
    <img src={src} alt="" className={`w-20 h-20 rounded-lg object-cover border ${main ? "border-amber-500 ring-2 ring-amber-300" : "border-slate-200"}`} />
    {main && <span className="absolute bottom-1 left-1 px-1.5 rounded bg-amber-500 text-white text-[9px] font-bold">UTAMA</span>}
    <button type="button" onClick={onDel} data-testid={`${tid}-del`} className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-rose-500 text-white grid place-items-center"><X className="w-3 h-3" /></button>
    {!main && onMain && <button type="button" onClick={onMain} title="Jadikan foto utama" data-testid={`${tid}-main`} className="absolute -top-1.5 -left-1.5 w-5 h-5 rounded-full bg-white border border-slate-300 text-amber-500 grid place-items-center"><Star className="w-3 h-3" /></button>}
  </div>
);

export const VariantPhotos = ({ v, setV, pend, setPend }) => {
  const [edit, setEdit] = useState(null);
  const saved = [v.image_path, ...(v.gallery || [])].filter(Boolean);
  const urls = useMemo(() => pend.map((b) => URL.createObjectURL(b)), [pend]);
  const total = saved.length + pend.length;
  const apply = (data) => setV({ ...v, image_path: data.photos[0] || "", gallery: data.photos.slice(1) });
  const call = async (fn, local) => { if (!v.id) { apply({ photos: local }); return; } try { apply((await fn()).data); } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); } };
  return (
    <div data-testid="var-photos">
      <span className="text-xs font-mono text-slate-500">FOTO PRODUK ({total}/{MAX_PHOTOS}) · foto utama tampil di kartu & PDF</span>
      <div className="mt-2 flex flex-wrap items-center gap-3">
        {saved.map((p, i) => <Thumb key={p} src={`${BACKEND}/api/files/${p}`} main={i === 0} tid={`var-photo-${i}`} onDel={() => window.confirm("Hapus foto ini?") && call(() => api.delete(`/catalog/variants/${v.id}/photos/${i}`), saved.filter((_, j) => j !== i))} onMain={() => call(() => api.put(`/catalog/variants/${v.id}/photos/${i}/main`), [p, ...saved.filter((_, j) => j !== i)])} />)}
        {urls.map((u, i) => <Thumb key={u} src={u} main={!saved.length && i === 0} tid={`var-photo-new-${i}`} onDel={() => setPend(pend.filter((_, j) => j !== i))} />)}
        {total < MAX_PHOTOS && <label className="w-20 h-20 rounded-lg border-2 border-dashed border-slate-300 grid place-items-center text-slate-400 hover:border-sky-400 hover:text-sky-500 cursor-pointer text-[11px] text-center" data-testid="var-image-input">
          <span><Plus className="w-5 h-5 mx-auto" />Pilih foto</span>
          <input type="file" accept="image/*" className="hidden" onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) setEdit(f); }} />
        </label>}
      </div>
      {pend.length > 0 && <p className="text-[11px] text-amber-600 mt-1">Foto baru tersimpan saat klik Simpan.</p>}
      {edit && <PhotoEditor file={edit} onCancel={() => setEdit(null)} onDone={(b) => { setPend([...pend, b]); setEdit(null); }} />}
    </div>
  );
};

export const uploadPending = async (vid, pend) => {
  for (const b of pend) { const fd = new FormData(); fd.append("file", b, "foto.jpg"); await api.post(`/catalog/variants/${vid}/photos`, fd); }
};
